var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5118 4.4872L15.865 4.13329V4.13329L15.5118 4.4872ZM6.33334 16V16.5C6.46578 16.5 6.59281 16.4475 6.68655 16.3539L6.33334 16ZM4 16H3.5C3.5 16.2761 3.72386 16.5 4 16.5V16ZM4 13.624L3.6468 13.2701C3.55281 13.3639 3.5 13.4912 3.5 13.624H4ZM13.508 4.8411C13.9637 4.3863 14.7029 4.3863 15.1586 4.8411L15.865 4.13329C15.019 3.2889 13.6477 3.2889 12.8016 4.13329L13.508 4.8411ZM15.1586 4.8411C15.6138 5.29535 15.6138 6.03143 15.1586 6.48568L15.865 7.19348C16.7117 6.34855 16.7117 4.97823 15.865 4.13329L15.1586 4.8411ZM15.1586 6.48568L5.98014 15.6461L6.68655 16.3539L15.865 7.19348L15.1586 6.48568ZM6.33334 15.5H4V16.5H6.33334V15.5ZM12.8016 4.13329L3.6468 13.2701L4.3532 13.9779L13.508 4.8411L12.8016 4.13329ZM3.5 13.624V16H4.5V13.624H3.5ZM11.8016 5.83913L14.1586 8.19152L14.865 7.48371L12.508 5.13133L11.8016 5.83913Z",
    fill: "#8492CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.f5b390ee72fb1107e65111ea78465b9e.svg";
export { ForwardRef as ReactComponent };